import { addBusinessDays, differenceInBusinessDays } from 'date-fns';

import { ReactComponent as TrackingSupportIcon } from 'assets/dialogue-avatar-tracking-support.svg';
import { extLnkContextualHelp } from 'config/track-config';
import { DialogueCardData, DialogueType } from 'models/DialogCard';
import { formatJSDate, localJSDateFromISO } from 'utils/date.utils';

import ArrowLink from './Arrows/ArrowLink';

export const RECIPIENT_CONTEXTUAL_HELP_TEST_ID = 'RecipientContextualHelpTestId';
export const SENDER_CONTEXTUAL_HELP_TEST_ID = 'SenderContextualHelpTestId';

export function getLateEddCard(latestEdd: string | null, articleId: string): DialogueCardData | null {
  if (!latestEdd) return null;

  const businessDaysDelayed = differenceInBusinessDays(new Date(), localJSDateFromISO(latestEdd));
  if (!businessDaysDelayed || businessDaysDelayed < 1) return null;

  const customerEnquiryDay = 10;

  let title;
  let content;
  let actions;

  const recipientUrl = `${extLnkContextualHelp}${articleId}&source=WEB_RECEIVER`;
  const senderUrl = `${extLnkContextualHelp}${articleId}&source=WEB_SENDER`;

  if (businessDaysDelayed <= customerEnquiryDay - 1) {
    const startEnquiryDate = addBusinessDays(localJSDateFromISO(latestEdd), customerEnquiryDay);
    const dateStr = formatJSDate(startEnquiryDate, 'EEEE d MMMM');
    title = 'Let’s keep an eye on this one';
    content = startEnquiryDate && (
      <p>
        Late parcels usually arrive within a few days of their expected delivery date. If this hasn’t arrived by&nbsp;
        {dateStr}, we’ll investigate.
      </p>
    );
  } else {
    title = 'Right, let’s investigate';
    content = (
      <p>
        Sorry this one has taken so long. Tell us if you’re the recipient or sender so we can help you with next steps.
      </p>
    );
    actions = (
      <>
        <ArrowLink href={recipientUrl} data-testid={RECIPIENT_CONTEXTUAL_HELP_TEST_ID}>
          I&apos;m the recipient
        </ArrowLink>
        <ArrowLink href={senderUrl} data-testid={SENDER_CONTEXTUAL_HELP_TEST_ID}>
          I&apos;m the sender
        </ArrowLink>
      </>
    );
  }

  return {
    analyticsId: 'lateEdd',
    type: DialogueType.TRACKING_SUPPORT,
    icon: <TrackingSupportIcon />,
    title,
    content,
    actions,
  };
}
